<style lang="less">
.acctplus{
	.acctplus_head{
		//样式在 app.vue
		.desc{
			display: -webkit-box; display:flex;
			-webkit-box-align: center; align-items: center;
			-webkit-box-pack: center; justify-content: center;
			p{
				padding-top: 3px;
			}
			img{
				height: 11px;
			}
		}
	}
	.account{
		text-align: center;
		padding: 6px 12px 6px;
		font-size: 12px;
		color: #DC2A2A;
	}
	.viewDetail{
		padding: 0 12px;
		border-top: 12px solid #f2f2f2;
	}
}
</style>

<template>
	<!-- Main acctplus -->
	<section class="acctplus">

		<toptips :tips="identity.message" v-if="showTopTips">
			<slot v-if="identity.status != 20">
				<router-link  class="toidentity" :to="{name: 'verify', query: {redirect: 'Acctplus'}}" >立即验证</router-link>
			</slot>
		</toptips>


		<toptips tips="完成测评后可享受收益" v-if="risk_grade.status == 0 || risk_grade.status == 3">
			<slot>
				<a href="javascript:;" @click="toEva">立即测评</a>
			</slot>
		</toptips>


		<div class="account_head acctplus_head">
			<template v-if="risk_grade.status == 0">
				<h1 class="price NOFont" @click="profit">{{acct.acct_account_info.money || 0}}</h1>
			</template>
			<template v-else>
				<h1 class="price NOFont" @click="profit">{{acct.acctplus_account_info.money || 0}}</h1>
			</template>
			<div class="desc" @click="profit">
				<p>总金额（元）</p>
				<!-- <img src="../assets/more.png"> -->
			</div>
			<template v-if="risk_grade.status != 0">
				<div class="account" v-if="dealingMoney > 0" @click="dealing_profit">
					处理中 {{dealingMoney.Format()}} 元
				</div>
			</template>
			<!-- <div class="account" v-if="acct.acct_account_info.avaliable_bal - acct.acct_account_info.frozen_bal > 0">
				申购中 {{(acct.acct_account_info.avaliable_bal - acct.acct_account_info.frozen_bal).toFixed(2)}} 元
			</div> -->
			<!-- <div class="button" v-if="acct.acct_status != 2">
				<button @click="account">开启收益</button>
			</div> -->
			<div class="info" @click="profit">
				<div class="item">
					<h3>{{acct.acctplus_account_info.profit_amt}}</h3>
					<p>总收益（元）</p>
				</div>
				<div class="item">
					<h3>{{acct.acctplus_account_info.recent_profit_amt}}</h3>
					<p>昨日收益（元）</p>
				</div>
			</div>
		</div>

		<div class="char">
			<div class="title">
				<h3>近七日年化收益率</h3>
				<p>万份收益：{{detail.exp_per_profit}}元</p>
			</div>
			<div class="cont">
				<char :charData="detail.history"></char>
			</div>
		</div>

		<div class="viewDetail">
			<item
				mark-subject="产品详情"
				submark-subject="国寿安保鑫钱包货币"
				ico-type="next"
				@click.native="viewDetail">
			</item>
		</div>

		<div class="cp">{{config.cp}}</div>
		<div class="space"></div>

		<footbtn btn-txt="转入" btn-ext="取出" :is-on="isActive" :is-exton="isExtActive" v-on:next="next" v-on:ext="ext"></footbtn>

	</section>
</template>

<script>
	import footbtn from '@flyme/jr/flyme7/component/foot-btn-simple/foot-btn-simple.vue';
	import android from '@flyme/jr/js/android.js';
	import item from '@flyme/jr/flyme7/component/item/vue-item.vue';


	import toptips from '../components/toptips.vue';
	import agreement from '../components/agreement.vue';
	import itembank from '../components/itembank.vue';
	import char from '../components/char_2.vue';

	import axios from '../axios.js';
	import apis from '../apis.js';
	import config from '../config.js';

	// import linchar from '../components/line-char.js';

	export default {
		data: function () {
			return {
				config: config,
				agree: true,
				identity: {
					status: 30 // -1:未上传 10:已上传(未调用银联接口) 15:上传银联失败 20：审核中 30:审核通过 40:审核失败
				},
				acct: {
					acct_status: 0,
					acct_account_info: {
						avaliable_bal: 0
					},
					acctplus_account_info: {
						recent_profit_amt: 0,
						profit_amt: 0,
						total_asset: 0
					}
				},
				detail: {
					during_num: '',
					total_asset: 0,
					history: {}
				},
				bank: {
					index: -1,
					isShow: false,
					data: []
				},
				userInfo: {},
				risk_grade: {},
				cache: true,
			};
		},
		computed: {
			isExtActive: function () {
				return this.acct.acctplus_account_info.total_asset > 0 ? true : false;
			},
			isActive: function() {
				if (this.agree) {
					return this.acct.acct_status == 2 ? true : false;
				}else{
					return false;
				}
			},
			showTopTips: function () {
				if (this.identity.status != 30) {
					return true;
				} else{
					return false;
				}
			},
			dealingMoney: function () {
				return Math.round((parseFloat(this.acct.acctplus_account_info.total_asset) - parseFloat(this.acct.acctplus_account_info.avaliable_asset) + parseFloat(this.acct.acct_account_info.avaliable_bal) + parseFloat(this.acct.acct_account_info.frozen_bal)) * 100 ) /100;
			}
		},
		components: {
			itembank,
			toptips,
			footbtn,
			agreement,
			char,
			item
		},
		created: function () {
			android('setTitle', {
				title:"余额+"
			});
			android('startLoading', {mes: '正在加载'});
			this.getProduct();
			this.initMenu();
		},
		mounted: function () {
			let _this = this;
			android('getUserInfo', {}, (d) => {
				_this.userInfo = d;
				_this.getDetail();
			});
		},
		beforeDestroy: function () {
			window.G_gotoVerify = null;
			this.removMenu();
		},
		methods: {
			initMenu: function () {
				let _this = this;
				android('addMenuItem', {
					key: 'order',
					text: '账单',
					enable: true
				}, function () {
					_this.orderList();
				});

			},
			removMenu: function () {
				android('removeAllMenuItem');
			},
			orderList: function () {
				let _this = this;
				android('startPageWithCallback', {
					url: config.staticURL + '/#/order/list',
					start_type:1,
					data:'',
					display:{
						title:'账单'
					}
				}, function () {
					_this.getDetail();
				});
			},
			getGrade: function () {
				//风险评测
				let _this = this;
				axios.post(apis.risk_grade_query, {}).then(function(d) {
					console.log('risk_grade_query', d);
					_this.risk_grade = d.value;
					android('stopLoading');
				});
			},
			tipsGrade: function () {
				// 状态 0:未评测 1：评测中 2:已评测 3:已评测但已过期
				window.G_toRisk = this.toEva;
				window.G_eva = this.eva;

				let msg = '';
				let cct = '我要测评';
				switch (this.risk_grade.status) {
					case 0:
					case 1:
						msg = '资金交易前，请先确认你的投资者类型';
						break;
					case 3:
						msg = '风险评测结果已过期，请确定你的投资者类型后再进行资金交易';
						cct = '重新测评';
						break;
				}
				android('showDialog', {
					title: '',
					message: msg,
					okText: '稳健型',
					cancelText: cct,
					okCallBack: 'G_eva',
					cancelCallback: 'G_toRisk',
					dismissCallback: ''
				});

			},
			eva: function () {
				let _this = this;

				android('showLoadingDialog', {
					mes: '正在加载'
				});

				axios.post(apis.risk_grade_evaluate, {
					type: 2
				}).then(function(d) {
					console.log('risk_grade_evaluate', d);
					android('hideLoadingDialog');
					if (d.value.result) {
						// _this.$router.replace({path: '/acctplus'});
						// _this.getDetail();
						android('startPageWithCallback', {
							url: config.staticURL + '/#/acctplus/charge?rate=' + _this.detail.rate,
							start_type:1,
							data:'',
							display:{
								title:'转入'
							}
						}, function () {
							// _this.getDetail();
							location.reload();
						});

					}
				});
			},
			toEva: function () {
				let _this = this;
				android('startPageWithCallback', {
					url: config.staticURL + '/#/evaluating',
					start_type:1,
					data:'',
					display:{
						title:'风险等级测评'
					}
				}, function () {
					_this.getDetail();
				});
			},
			account: function () {
				this.$router.push({ path: 'acctplus/info' });
				// android('startPageWithCallback', {
				// 	url: 'http://baidu.com',
				// 	start_type: 1,
				// 	data: '',
				// 	display: {
				// 		title: '完善资料'
				// 	}
				// }, "G_acct_cb");
			},
			getIdentity: function () {
				let _this = this;
				axios.post(apis.identity_img_query, {
					show_type: 1,
					sys_reserved_info: '{"uid": '+ _this.userInfo.userId +'}'
				}).then(function(d) {
					console.log('identity_img_query', d);
					// if (d.value.status == 10) {
					// 	d.value.message = '未上传身份证';
					// }
					_this.identity = d.value;
				});
			},
			getProduct: function () {
				let _this = this;
				axios.post(apis.acctplus_product_query, {
					show_type: 1
				}).then(function(d) {
					console.log('acctplus_product_query', d, d.value.history_rates);
					if (d.value) {
						d.value.history = {};
						_this.detail = d.value;
						_this.getCharData();
					}
				});
			},
			getCharData: function () {
				var data = this.detail.history_rates;
				var charData = {
					x: [],
					y: []
				};
				for( var i = data.length - 1; i >= 0; i--){
					charData.x.push(new Date(data[i].date).Format("MM/dd"));
					charData.y.push(data[i].rate);
				}
				if (charData.x.length > 7) {
					charData.x = charData.x.slice(-7);
					charData.y = charData.y.slice(-7);
				}
				this.detail.history = charData;
			},
			getDetail: function () {
				let _this = this;
				if (this.$route.query.acct_query && this.cache) {
					var d = JSON.parse(this.$route.query.acct_query);
					console.log('acct_query acctplus url', d);
					this.cache = false;
					this.setDetail(d);
					return;
				}

				axios.post(apis.acct_query, {
					show_type: 0
				}).then(function(d) {
					console.log('acct_query acctplus', d.value, d.value.acctplus_account_info);
					_this.setDetail(d.value);
				});
			},
			setDetail: function (data) {
				this.getIdentity();
				this.getGrade();
				if (!data.acctplus_account_info && data.acct_status === 2) {
					data.acctplus_account_info = {
						'total_asset': 0,
						'profit_amt': 0,
						'recent_profit_amt': 0
					};
					data.acctplus_account_info.recent_profit_amt = 0;
				}
				if (data.acct_account_info && data.acct_account_info.avaliable_bal) {
					data.acct_account_info.money = data.acct_account_info.avaliable_bal.Format();
				}
				if (data.acctplus_account_info && data.acctplus_account_info.avaliable_asset) {
					data.acctplus_account_info.money = data.acctplus_account_info.avaliable_asset.Format();
				}
				this.acct = data;
				android('stopLoading');
			},
			next: function () {
				// this.$router.push({path: '/acctplus/charge'});
				if (this.risk_grade.status != 2) {
					this.tipsGrade();
					return;
				}
				let _this = this;
				android('startPageWithCallback', {
					url: config.staticURL + '/#/acctplus/charge?rate=' + this.detail.rate,
					start_type:1,
					data:'',
					display:{
						title:'转入'
					}
				}, function () {
					_this.getDetail();
					_this.getProduct();
				});
			},
			ext: function () {
				// this.$router.push({path: '/acctplus/takeout'});
				// 审核不通过并且不是审核中，提示用户进行验证
				if (this.identity.status !== 30 && this.identity.status !== 20) {
					if (!window.G_gotoVerify) {
						window.G_gotoVerify = this.gotoVerify;
					}
					android('showDialog', {
						title: '',
						message: '身份证照未通过验证，取出资金需先完成身份验证。',
						okText: '立即验证',
						cancelText: '取消',
						okCallBack: 'G_gotoVerify',
						cancelCallback: '',
						dismissCallback: ''
					});
					return;
				}

				let _this = this;
				android('startPageWithCallback', {
					url: config.staticURL + '/#/acctplus/takeout',
					start_type:1,
					data:'',
					display:{
						title:'取出'
					}
				}, function () {
					_this.getDetail();
				});
			},
			dealing_profit: function () {
				let _this = this;
				android('startPageWithCallback', {
					url: config.staticURL + '/#/order/list?order_statuses=8-32',
					start_type:1,
					data:'',
					display:{
						title:'账单'
					}
				}, function () {
					_this.getDetail();
				});
			},
			profit: function () {
				let _this = this;
				android('startPageWithCallback', {
					url: config.staticURL + '/#/acctplus/profit',
					start_type:1,
					data:'',
					display:{
						title:'收益明细'
					}
				}, function () {
					_this.getDetail();
					_this.getProduct();
				});
			},
			viewDetail: function () {
				android('startPage', {
					url: config.staticURL + '/#/acctplus/detail',
					start_type:1,
					data:'',
					display:{
						title:'国寿安保鑫钱包'
					}
				});
			},
			gotoVerify() {
				this.$router.push({name: 'verify', query: {redirect: 'Acctplus'}})
			}
		}
	};
</script>


// WEBPACK FOOTER //
// src/pages/Acctplus.vue